module.exports = __webpack_public_path__ + "media/images/common/logo/logo-w-be6b8d18526820a2a13c6f3da6ec818c.svg";